export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export enum PhoneType {
  LANDLINE = 'LANDLINE',
  MOBILE = 'MOBILE'
}

export enum PersonType {
  BENEFICIARY = 'BENEFICIARY',
  INSURED = 'INSURED',
  INTRODUCED_BY = 'INTRODUCED_BY',
  OWNER = 'OWNER',
  PAYER = 'PAYER'
}
